import { render } from "./Tests.vue?vue&type=template&id=cebad414&scoped=true"
import script from "./Tests.vue?vue&type=script&lang=js"
export * from "./Tests.vue?vue&type=script&lang=js"

import "./Tests.vue?vue&type=style&index=0&id=cebad414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebad414"]])

export default __exports__